export default __webpack_public_path__ + "static/media/events.8f34eb48.jpg";